import {join as _join} from 'lodash';

import {getSortingTerritories} from '@utils/countryHelpers';
import {
    prepareClients, prepareEventContents, prepareUsages,
} from '@modules/events/utils/eventGeoRestrictionsHelper';

export const columns = {
    'id': {
        label: 'ID',
        sorting: (row) => parseInt(row.id, 10),
        header: {
            align: 'center',
            isCollapsed: true,
        },
        content: {
            align: 'center',
        },
    },
    'clients': {
        label: 'Clients',
        sorting: (row) => prepareClients(row, 'clients'),
    },
    'event_contents': {
        label: 'Contents',
        sorting: (row) => prepareEventContents(row, 'event_contents'),
    },
    'usages': {
        label: 'Usage',
        sorting: (row) => prepareUsages(row.usages).map((product) =>
            product.device_categories.map((deviceCategory) =>
                product.short_name +
                ' > ' + deviceCategory.name +
                ' > ' + _join(deviceCategory.way_of_transmissions, ' / ')
            )
        ),
    },
    'countries': {
        label: 'Territories',
        sorting: (row) => getSortingTerritories(row),
    },
    'blackoutZones': {
        label: 'Blackout Zones',
        sorting: row => {
            return row.blackout_zones.map((blackoutZone) => blackoutZone.name).sort().join(', ');
        },
    },
    'notes': {
        label: 'Notes',
        sorting: (row) => row.notes ? row.notes : '',
    },
    'actions': {
        label: 'Actions',
        header: {
            align: 'center',
            isCollapsed: true,
        },
        content: {
            align: 'center',
        },
    },
};
